import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { fetchDetailNews,fetchNews, } from 'actions/PublicNews'
import DetailInfoBerita from 'components/publicPages/infoBerita/detail'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  fetchDetailNews: bindActionCreators(fetchDetailNews, dispatch),
  fetchNews: bindActionCreators(fetchNews, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('data', 'setData', {}),
  withState('news', 'setNews', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const { setData } = props
      props.fetchDetailNews(id)
        .then((res) => {
          setData(res)
        })
        .catch(() => {
          setData({})
        })
    },
  }),
  withHandlers({
    getList: props => async (params) => {
      const { setNews } = props
      try {
        const res = await props.fetchNews(params)
        setNews({
          list: res.data,
          meta: res.meta,
        })
      } catch (err) {
        console.log(err)
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.getDetail(this.props.match.params.id)
      this.props.getList(`?limit=6&status=active`);
    },
  }),
)(DetailInfoBerita)
